<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Price Limits"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="METRC Price Limits" with-footer>
          <template v-slot:header-right>
            <div>
              <no-permission-wrapper :show="!canUpdatePriceLimits">
                <b-btn
                    variant="primary"
                    @click.prevent="savePriceLimits"
                    :disabled="!canUpdatePriceLimits"
                >
                  Save Price Limits
                  <b-spinner v-if="formState.processing" class="ml-1" small/>
                </b-btn>
              </no-permission-wrapper>
            </div>
          </template>
          <b-table
              :fields="tableFields"
              :items="priceLimits"
              table-class="text-nowrap"
              responsive
              hover
          >
            <template #cell(unit_type)="data">
              <b-form-select
                  v-model="priceLimits[data.index].unit_type"
                  :options="unitTypesOptions"
                  :disabled="!canUpdatePriceLimits"
              />
            </template>
            <template #cell(min_price)="data">
              <b-form-input
                  v-model="priceLimits[data.index].min_price"
                  type="number"
                  :disabled="!canUpdatePriceLimits"
              />
            </template>
            <template #cell(max_price)="data">
              <b-form-input
                  v-model="priceLimits[data.index].max_price"
                  type="number"
                  :disabled="!canUpdatePriceLimits"
              />
            </template>
          </b-table>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminPreloader from "../components/AdminPreloader.vue";
import AdminBreadcrumb from "../components/AdminBreadcrumb.vue";
import AdminPanel from "../components/AdminPanel.vue";
import {API_ROUTES} from "../api";
import {MEASURE_UNIT_TYPES_OPTIONS} from "../constants";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";

export default {
  name: "AdminPriceLimits",
  components: {NoPermissionWrapper, AdminPanel, AdminBreadcrumb, AdminPreloader},
  data() {
    return {
      loading: true,
      priceLimits: [],
      formState: {
        processing: false
      },
      unitTypesOptions: MEASURE_UNIT_TYPES_OPTIONS,
      tableFields: [
        {
          key: "category_type",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "category_name",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "unit_type",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "min_price",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "max_price",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
      ]
    }
  },
  computed: {
    canUpdatePriceLimits() {
      return this.$store.getters['auth/hasAdminPermissions']('price_limit_update');
    }
  },
  methods: {
    loadPriceLimits() {
      this.$api.get(API_ROUTES.ADMIN_PRICE_LIMITS).then(({data}) => {
        this.priceLimits = data.price_limits;
      }).catch(({response}) => {

      }).finally(() => {
        this.loading = false;
      })
    },
    savePriceLimits() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.ADMIN_PRICE_LIMITS, {
        price_limits: this.priceLimits
      }).then(() => {

      }).catch(({response: {data}}) => {
        console.log(data);
        this.$bvToast.toast(data.message ?? 'Failed to create a new category', {
          title: 'Error!',
          variant: 'danger'
        });
      }).finally(() => {
        this.formState.processing = false;
      })
    }
  },
  created() {
    this.loadPriceLimits();
  }
}
</script>
